module.exports = __webpack_public_path__ + "img/電気回路_1_7.8860a7e5.png";